<header class="import-header">
    <qpx-hero-icon name="lucideUsers" context="caution" [active]="true" />
    <div class="min-w-0">
        <h3 qpxHeading variant="sm" [id]="headingId()">
            {{ title() }}
        </h3>
        <p qpxBody="secondary" size="sm" [id]="descriptionId()">
            {{ effectiveDescription() }}
        </p>
    </div>
</header>

<ul
    class="candidate-list scrollbar-caution"
    [attr.aria-label]="`${title()} candidates`"
>
    @for (candidate of candidates(); track candidate) {
        <li>
            <mat-checkbox
                qpx
                density="compact"
                [id]="candidateId($index)"
                [aria-label]="candidate"
                [checked]="isCandidateSelected(candidate)"
                [disabled]="isCandidateDisabled(candidate)"
                (change)="toggleCandidate(candidate, $event.checked)"
            >
                {{ candidate }}
            </mat-checkbox>
        </li>
    } @empty {
        <li qpxBody="secondary" size="sm">No recipients available</li>
    }
</ul>

<output class="sr-only" aria-live="polite" aria-atomic="true">
    {{ selectionSummary() }}
</output>

<div class="import-actions">
    <button
        qpxButton
        matButton="outlined"
        size="sm"
        [disabled]="disabled()"
        (click)="cancel()"
    >
        <span>{{ cancelLabel() }}</span>
    </button>
    <button
        qpxButton
        matButton="filled"
        context="primary"
        size="sm"
        [disabled]="!canConfirm()"
        (click)="confirm()"
    >
        <span>{{ effectiveConfirmLabel() }}</span>
    </button>
</div>
